import * as gs from './_csGbl';
import * as f from './_cmFTH';

import * as hf from './_hf';
import * as ht from './_ht';
import * as ihd from 'src/ihd';

export const itl_61z = () => ({ // 新規登録を考慮し、毎回新規生成
  _61rz: {},
  _611s: [],
}) as ht.dz;

export const crt_61z = async () => {
  const _gUserz = gs.useUserz();
  const __61z = itl_61z();
  hf.udtDz(__61z._61rz, {
    ... ihd.i('_61r'),
    _61r_31r1f: _gUserz.crt._31rz._fst,
  });
  __61z._611s = [];
  return __61z;
};

export const load_61rLsAsync = async (pz: {
  cdn: ht.s,
}) => {
  let _cdn = f.vdd();
  _cdn += ` AND (${pz.cdn})`;
  //hf.l(`_cv_61 29: ${pz.cdn}`)
  const _ls = await f.loadLsAsync({
    tgt: '_61rs',
    cdn: _cdn,
    fld: '*',
  });
  return _ls;
};

export const load_611AsAsync = async ( pz: {
  _31r_fst?: ht.n,
  date?: ht.s,
  dates?: ht.ls,
  yearMth?: ht.s,
  dateStt?: ht.s,
  dateEnd?: ht.s,
  cdn?: ht.s, // 設定忘れを防ぐため必ず設定、不要な場合は true
} ) => {
  let _cdn = f.vdd();
  if (pz._31r_fst) _cdn += ` AND _611_31r1f = ${pz._31r_fst}`;
  if (pz.date) _cdn += ` AND _icn = '${pz.date}'`;
  if (pz.dates) _cdn += ` AND _icn IN (${hf.join(pz.dates, ',', `'`)})`;
  if (pz.yearMth) _cdn += ` AND _icn LIKE '${pz.yearMth}%'`;
  if (pz.dateStt) _cdn += ` AND _icn >= '${pz.dateStt}'`;
  if (pz.dateEnd) _cdn += ` AND _icn <= '${pz.dateEnd}'`;
  _cdn += ` AND (${pz.cdn})`;
  //hf.l(`_cv_61_Mz 55: ${_cdn}`);
  const _ls = await f.loadLsAsync({
    tgt: '_611s',
    cdn: _cdn,
    fld: '*',
  });
  return _ls.map( (_dz: ht.dz) => _dz._icn);
};

export const load_61rDzAsync = async (pz: {
  _61r_fst: ht.n,
  cdn: ht.s,
  vsn?: ht.n,
}) => {
//  let _cdn = f.vdd() + ` AND _fst=${pz._61r_fst}`;
  let _cdn = (pz?.vsn && pz?.vsn > 0) ? (f.vdd(false) + ` AND _vsn = ${pz?.vsn}`) : f.vdd();
  _cdn += ` AND _fst = ${pz._61r_fst}`;
  _cdn += ` AND (${pz.cdn})`;
  const _dz = await f.loadDzAsync({
    tgt: '_61rs',
    cdn: _cdn,
    lwrz: {
      _611s: {
        tgt: '_611s',
        cdn: f.vdd(false) + ` AND _611_61r1k = {_61r_key}`,
        rlcz: {
          _61r_key: '_61rs._key',
        },
      },
    }
  });
  return {
    _61rz: { ... _dz, cldz: undefined },
    _611s: _dz.cldz?._611s ?? [],
  };
};

export const save_61rDzAsync = async (pz: {
  _61z: ht.dz,
  sPz?: ht.dz,
}) => {
  //hf.l(`_cv_61 85: ${hf.s(pz._61z)}`);
  const _dz = await f.ugdDzAsync({
    tgt: '_61rs',
    dz: {
      ... pz._61z._61rz,
    },
    lwrz: {
      _611s: {
        tgt: '_611s',
        ls: pz._61z._611s,
/*
        rlcz: {
          _611_31r1f: '_61rs._61r_31r1f',
          _611_61r1k: '_61rs._key',
        }
*/
        udtz: {
          _611_31r1f: '_61rs._61r_31r1f',
          _611_61r1k: '_61rs._key',
        }
      },
    }
  });
  //hf.l(`_cv_61 102: ${hf.s(_dz)}`);
  if (pz.sPz) pz.sPz.set({
    _fst: _dz._fst,
    _key: _dz._key,
  })
  return {
    _61rz: { ... _dz, cldz: undefined },
  };
};
